import Decimal from 'decimal.js';

import { toBN } from '@utils/formaters.utils';

import { MAX_FARMS_LIST } from '@constants/vaults/common.constants';

import { CommonTokenDto } from '@dto/common/tokens.dto';
import { TokensDto } from '@dto/vaults/tokens.dto';
import { VaultFactoryDto } from '@dto/vaults/vault-factory.dto';
import { LegacyVaultsDto, VaultDto } from '@dto/vaults/vaults.dto';

import { AssetToken } from '@app-types/common/token.types';
import { PositionManagerInfoItem } from '@app-types/vaults/positionManagerInfo.types';
import {
  PoolV3SqrtPriceInfoItem,
  PriceRangeInfoItem,
} from '@app-types/vaults/priceRange.types';
import {
  HarvestInfoType,
  PendingRewardsWithAccountType,
  VaultFarmsType,
} from '@app-types/vaults/vault.types';

export interface VaultContextType {
  vault: LegacyVaultsDto;
  vaultInfo: VaultInfoType;
}

export type VaultFarmsV3ItemType = PriceRangeInfoItem &
  PositionManagerInfoItem &
  PoolV3SqrtPriceInfoItem;

export type VaultFarmsV3InfoType = Record<number, VaultFarmsV3ItemType>;

export interface VaultInfoType {
  vaultTitle: string;
  isFullCompound: boolean;
  isFullProfit: boolean;
  hasAccountBalance: boolean;
  isNoAccountDeposit: boolean;
  // isBoostedVault: boolean;
  // isSavedVault: boolean;
  isInitialized: boolean;
  isSingleFarmVault: boolean;
  harvestInfoLoading: boolean;
  availableToClaimLoading: boolean;
  maxFarmsCount: number;
  farmsCounter: string | null;
  // apy: Decimal;
  tvlUsd: Decimal;
  // netApy: Decimal;
  // dailyApy: Decimal;
  // boostApy: Decimal;
  investUsd: Decimal;
  profitUsd: Decimal;
  farmsTvlUsd: Decimal;
  syntheticUsd: Decimal;
  // boostDailyApy: Decimal;
  availableToClaim: Decimal;
  takeProfitPercent: Decimal;
  compoundPercent: Decimal;
  availableToClaimUsd: Decimal;
  totalSupply: Decimal;
  userBalance: Decimal;
  claimValueUsd: Decimal;
  accountBalance: Decimal;
  withV3Farm: boolean;
  harvestInfo: HarvestInfoType;
  vaultFarms: VaultFarmsType[];
  vaultV3Farms: VaultFarmsType[];
  vaultFactory: VaultFactoryDto;
  profitToken: (CommonTokenDto & { tokenList?: CommonTokenDto[] }) | null;
  vaultFarmsV3Info: VaultFarmsV3InfoType;
  // depositTokens: AssetToken[];
  // withdrawTokens: AssetToken[];
  // userNftInfo: PositionManagerInfoItem[];
  // pendingRewards: PendingRewardsWithAccountType[];
  tokens: TokensDto | undefined;
}

export const INITIAL_VAULT_CONTEXT: VaultContextType = {
  vault: {} as LegacyVaultsDto,
  vaultInfo: {
    vaultTitle: '',
    vaultFarms: [],
    vaultV3Farms: [],
    profitToken: null,
    withV3Farm: false,
    isFullCompound: false,
    isFullProfit: false,
    // isSavedVault: false,
    isSingleFarmVault: false,
    hasAccountBalance: false,
    isInitialized: false,
    // isBoostedVault: false,
    isNoAccountDeposit: false,
    harvestInfoLoading: false,
    availableToClaimLoading: false,
    maxFarmsCount: MAX_FARMS_LIST,
    farmsCounter: null,
    // apy: toBN(0),
    // netApy: toBN(0),
    tvlUsd: toBN(0),
    // boostApy: toBN(0),
    // dailyApy: toBN(0),
    investUsd: toBN(0),
    profitUsd: toBN(0),
    accountBalance: toBN(0),
    farmsTvlUsd: toBN(0),
    claimValueUsd: toBN(0),
    // boostDailyApy: toBN(0),
    compoundPercent: toBN(0),
    availableToClaim: toBN(0),
    takeProfitPercent: toBN(0),
    availableToClaimUsd: toBN(0),
    totalSupply: toBN(0),
    userBalance: toBN(0),
    syntheticUsd: toBN(0),
    vaultFactory: {} as VaultFactoryDto,
    harvestInfo: {
      harvestAmountUsd: toBN(0),
      profitAmountUsd: toBN(0),
    },
    vaultFarmsV3Info: {},
    tokens: undefined,
    // depositTokens: [],
    // withdrawTokens: [],
    // userNftInfo: [],
    // pendingRewards: [],
  },
};
